<span role="alert" [id]="id()" class="field-error" aria-live="atomic" aria-live="true">
  <ng-content />
</span>
